import { createSelector } from "@reduxjs/toolkit";
export const selectIsDeviceInCart = (state) => state.cart.items.some((item) => Boolean(item.hasDevice));
export const selectHasFirstPurchase = (state) => state.loyaltyCore.reminder.hasFirstPurchase;
export const selectParentCodeExists = (state) => state.loyaltyCore.reminder.parentCodeExists;
export const selectIsReferralOn = (state) => state.loyaltyCore.isReferralOn;
export const selectShouldShowLoyaltyReminderDialog = createSelector([selectIsDeviceInCart, selectHasFirstPurchase, selectParentCodeExists, selectIsReferralOn], (isDeviceInCart, hasFirstPurchase, parentCodeExists, isReferralOn) => {
    return isReferralOn && !isDeviceInCart && !hasFirstPurchase && parentCodeExists;
});
//# sourceMappingURL=selectLoyaltyDeviceReminder.js.map